"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CurrencyRate_1 = require("../model/CurrencyRate");

var CurrencyRateConverter_1 = require("./CurrencyRateConverter");
/**
 * Implementation of {@link CurrencyRateConverter}.
 *
 * @author RV
 * @author JMe
 */


var CurrencyRateConverterImpl =
/*#__PURE__*/
function (_CurrencyRateConverte) {
  _inherits(CurrencyRateConverterImpl, _CurrencyRateConverte);

  function CurrencyRateConverterImpl() {
    _classCallCheck(this, CurrencyRateConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(CurrencyRateConverterImpl).apply(this, arguments));
  }

  _createClass(CurrencyRateConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new CurrencyRate_1.CurrencyRate(CurrencyRate_1.CurrencyRate.schema.validFrom.valueOfField(source), CurrencyRate_1.CurrencyRate.schema.validTo.valueOfField(source), conversions.toBigNumber(source.rate));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        validFrom: conversions.fromDate(source.validFrom),
        validTo: conversions.fromDate(source.validTo),
        rate: conversions.fromBigNumber(source.rate)
      });
      return result;
    }
  }]);

  return CurrencyRateConverterImpl;
}(CurrencyRateConverter_1.CurrencyRateConverter);

exports.CurrencyRateConverterImpl = CurrencyRateConverterImpl;